import { render } from "./AssignmentEditor.vue?vue&type=template&id=b01a12e2&scoped=true"
import script from "./AssignmentEditor.vue?vue&type=script&lang=js"
export * from "./AssignmentEditor.vue?vue&type=script&lang=js"

import "./AssignmentEditor.vue?vue&type=style&index=0&id=b01a12e2&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/ru/views/assignment-editor.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAssignmentEditor.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/views/assignment-editor.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAssignmentEditor.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01a12e2"]])

export default __exports__